// extracted by mini-css-extract-plugin
module.exports = {"copyItem":"copyItem_copyItem__D7-Zs","copied":"copyItem_copied__3JVjf"};